import React, { useContext, useEffect, useMemo, useState } from "react";
import { Button } from "react-bootstrap";
import { BsFillPencilFill } from "react-icons/bs";
import { ModalTambahLead, ModalUbahLead } from "../../../Modal";
import { useLocation } from "react-router-dom";
import { IoEye } from "react-icons/io5";
import { AgGridReact } from "ag-grid-react";
import {
  AllCommunityModule,
  ModuleRegistry,
  colorSchemeDark,
  colorSchemeLightCold,
  DateFilterModule,
  themeQuartz,
} from "ag-grid-community";
import { ThemeContext } from "../../../../auth";
import { useMediaQuery } from "react-responsive";
import { axiosAuth } from "../../../../api";
import { FaWindowClose } from "react-icons/fa";
import Swal from "sweetalert2";
import ExportExcel from "../../../ExportExcel";
ModuleRegistry.registerModules([AllCommunityModule, DateFilterModule]);

function TableLeadDark({
  retrieveLead,
  listLead,
  accessToken,
  retrieveCustomer,
  listCustomer,
  name,
}) {
  const isMobile = useMediaQuery({ maxWidth: 736 });
  const { theme } = useContext(ThemeContext);
  const location = useLocation();

  const [showTambahLead, setShowTambahLead] = useState(false);
  const handleShowTambahLead = () => {
    setShowTambahLead(true);
  };
  const [gridApi, setGridApi] = useState(null);
  const [rowSelected, setRowSelected] = useState();
  const [showEditLead, setShowEditLead] = useState(false);
  const handleShowEditLead = (row) => {
    setShowEditLead(true);
    setRowSelected(row);
  };
  const onGridReady = (params) => {
    setGridApi(params.api);
  };
  const [dataTable, setDataTable] = useState([]);

  useEffect(() => {
    if (!Array.isArray(listLead)) {
      setDataTable([]);
      return;
    }

    const capitalize = (str) =>
      typeof str === "string" && str.length > 0
        ? str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()
        : "";

    const dataTableFilter = listLead.map(({ ...rest }) => rest);

    setDataTable(
      dataTableFilter.map((data) => {
        return {
          ...data,
          customerName:
            data?.customer?.title?.titleName === "Others"
              ? data?.customer?.name
              : `${data?.customer?.title?.titleName}. ${data?.customer?.name}`,
          status_lead: data?.status + "%",
          leadType: capitalize(data?.orderType),
        };
      }),
    );
  }, [listLead]);

  const themeLightCold = themeQuartz.withPart(colorSchemeLightCold);
  const themecolorSchemeDark = themeQuartz.withPart(colorSchemeDark);

  const [rowData, setRowData] = useState([]);

  useEffect(() => {
    setRowData(Array.isArray(dataTable) ? dataTable : []);
  }, [dataTable]);
  const filterParams = {
    comparator: (filterLocalDateAtMidnight, cellValue) => {
      if (!cellValue) return -1;

      const dateParts = cellValue.split("-");
      const cellDate = new Date(
        Number(dateParts[0]),
        Number(dateParts[1]) - 1,
        Number(dateParts[2]),
      );

      if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
        return 0;
      }
      return cellDate < filterLocalDateAtMidnight ? -1 : 1;
    },
    minValidYear: 2000,
    inRangeFloatingFilterDateFormat: "Do MMM YYYY",
  };

  const handleDelete = async (rowId) => {
    const result = await Swal.fire({
      title: "Hapus Lead ini?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Ya",
      cancelButtonText: "Batalkan",
    });

    if (result.isConfirmed) {
      try {
        const response = await axiosAuth.delete(`/api/leads/${rowId}`, {
          headers: {
            "Access-Control-Allow-Origin": "*",
            withCredentials: true,
            Authorization: `Bearer ${accessToken}`,
          },
        });

        Swal.fire("Berhasil!", "Lead berhasil dihapus", "success");
        retrieveLead();
        // retrieveCustomer();
      } catch (err) {
        console.error(err);
        Swal.fire("Error", "Terjadi kesalahan saat menghapus lead!", "error");
      }
    } else {
      <></>;
    }
  };

  const colDefs = [
    {
      field: "noLead",
      headerName: "No. Lead",
      sortable: true,
      cellRenderer: (row) => (
        <div
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "left",
            justifyContent: "left",
            cursor: "pointer",
          }}
        >
          {row?.data?.noLead}
        </div>
      ),
    },
    {
      field: "date",
      headerName: "Tanggal",
      filter: "agDateColumnFilter",
      sort: "desc",
      filterParams: filterParams,
    },
    {
      field: "customerName",
      headerName: "Customer",
      sortable: true,
      cellRenderer: (row) => (
        <div
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "left",
            justifyContent: "left",
            cursor: "pointer",
          }}
        >
          {row?.data?.customerName}
        </div>
      ),
    },
    {
      field: "leadType",
      headerName: "Tipe Lead",
      sortable: true,
      cellRenderer: (row) => (
        <div
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "left",
            justifyContent: "left",
            cursor: "pointer",
          }}
        >
          {row?.data?.leadType}
        </div>
      ),
    },
    {
      field: "pcpStatus",
      headerName: "Status PCP",
      sortable: true,
      cellRenderer: (row) => {
        const pcpStatus = row?.data?.pcpStatus || "Belum ada PCP";

        let color = "";
        if (pcpStatus.toLowerCase() === "approved") {
          color = "green";
        } else if (pcpStatus.toLowerCase() === "denied") {
          color = "red";
        } else if (pcpStatus.toLowerCase() === "pending") {
          color = "orange";
        } else {
          color = "gray";
        }

        return (
          <div
            style={{
              width: "100%",
              height: "100%",
              display: "flex",
              alignItems: "left",
              justifyContent: "left",
              color: color,
              fontWeight: "bold",
              cursor: "pointer",
            }}
          >
            {pcpStatus}
          </div>
        );
      },
    },
    {
      field: "status_lead",
      headerName: "Progress Lead",
      sortable: true,
      cellRenderer: (row) => (
        <div
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "left",
            justifyContent: "left",
            cursor: "pointer",
          }}
        >
          {row?.data?.status_lead}
        </div>
      ),
    },
    {
      field: location.pathname === "/lead" ? "ubah" : "detail",
      headerName: location.pathname === "/lead" ? "Ubah" : "Detail",
      width: 100,
      pinned: "right",
      cellRenderer: (row) => (
        <div
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
          }}
          onClick={() => handleShowEditLead(row.data)}
        >
          <Button variant="btn" onClick={() => handleShowEditLead(row.data)}>
            {location.pathname === "/lead" ? (
              <BsFillPencilFill
                size={20}
                color={theme === "light" ? "#12B3ED" : "#006CB8"}
              />
            ) : (
              <IoEye
                size={20}
                color={theme === "light" ? "#12B3ED" : "#006CB8"}
              />
            )}
          </Button>
        </div>
      ),
    },
    ...(location.pathname !== "/lead"
      ? [
          {
            field: "hapus",
            headerName: "Hapus",
            width: 100,
            pinned: "right",
            cellRenderer: (row) => (
              <div
                style={{
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                }}
                onClick={() => handleDelete(row.data.id)}
              >
                <Button variant="btn" onClick={() => handleDelete(row.data.id)}>
                  <FaWindowClose size={20} color="#FF0060" />
                </Button>
              </div>
            ),
          },
        ]
      : []),
  ];

  const defaultColDef = {
    flex: 1,
    sortable: true,
    filter: true,
    resizable: true,
  };

  const [tableHeight, setTableHeight] = useState(window.innerHeight - 200); // Initial height

  useEffect(() => {
    const updateHeight = () => {
      setTableHeight(window.innerHeight - 200); // Adjust as needed
    };

    window.addEventListener("resize", updateHeight);
    return () => window.removeEventListener("resize", updateHeight);
  }, []);

  const getFilteredExportData = () => {
    // kalau gridApi belum siap, fallback ke rowData
    if (!gridApi) {
      console.log("gridApi belum siap, pakai rowData");
      return rowData.map((item, index) => ({
        No: index + 1,
        "No. Lead": item?.noLead || "",
        Tanggal: item?.date || "",
        Customer: item?.customerName || "",
        "Tipe Lead": item?.leadType || "",
        "Status PCP": item?.pcpStatus || "",
        "Progress Lead": item?.status_lead || "",
      }));
    }

    const rows = [];

    gridApi.forEachNodeAfterFilterAndSort((node, index) => {
      if (node?.data) {
        rows.push({
          No: index + 1,
          "No. Lead": node.data?.noLead || "",
          Tanggal: node.data?.date || "",
          Customer: node.data?.customerName || "",
          "Tipe Lead": node.data?.leadType || "",
          "Status PCP": node.data?.pcpStatus || "",
          "Progress Lead": node.data?.status_lead || "",
        });
      }
    });

    // kalau hasil grid kosong, fallback ke rowData juga
    if (rows.length === 0) {
      console.log("grid kosong, fallback ke rowData");
      return rowData.map((item, index) => ({
        No: index + 1,
        "No. Lead": item?.noLead || "",
        Tanggal: item?.date || "",
        Customer: item?.customerName || "",
        "Tipe Lead": item?.leadType || "",
        "Status PCP": item?.pcpStatus || "",
        "Progress Lead": item?.status_lead || "",
      }));
    }

    return rows;
  };

  console.log("rowData:", rowData);
  console.log("gridApi:", gridApi);
  return (
    <div style={{ height: tableHeight }}>
      <div style={{ display: "flex", gap: "10px", marginBottom: "10px" }}>
        {location.pathname == "/lead" ? (
          <Button
            id={
              theme === "light"
                ? "actionButtonTabelDark"
                : "actionButtonTabelLight"
            }
            variant="btn"
            style={{
              color: theme === "light" ? "#222" : "white",
              fontSize: "14px",
            }}
            onClick={handleShowTambahLead}
          >
            Tambah
          </Button>
        ) : null}

        <ExportExcel
          getExcelData={getFilteredExportData}
          fileName={`Data Lead ${name}`}
        />
      </div>
      <AgGridReact
        theme={theme === "light" ? themecolorSchemeDark : themeLightCold}
        rowData={rowData}
        columnDefs={colDefs}
        defaultColDef={defaultColDef}
        pagination={isMobile ? false : true}
        rowHeight={30}
        onGridReady={onGridReady}
      />

      <ModalTambahLead
        showTambahLead={showTambahLead}
        setShowTambahLead={setShowTambahLead}
        listLead={listLead}
        listCustomer={listCustomer}
        retrieveCustomer={retrieveCustomer}
        retrieveLead={retrieveLead}
        accessToken={accessToken}
      />
      <ModalUbahLead
        rowSelected={rowSelected}
        showEditLead={showEditLead}
        setShowEditLead={setShowEditLead}
        retrieveLead={retrieveLead}
        accessToken={accessToken}
        listCustomer={listCustomer}
        retrieveCustomer={retrieveCustomer}
      />
    </div>
  );
}

export default TableLeadDark;
